export const CONSONANT_VOWEL_PAIRS_P = [

    // ㅍ
    {
        id: 1,
        korean: "파",
        english: "pa",

    },
    {
        id: 2,
        korean: "페",
        english: "pe",

    },
    {
        id: 3,
        korean: "피",
        english: "pi",

    },
    {
        id: 4,
        korean: "포",
        english: "po",

    },
    {
        id: 5,
        korean: "프",
        english: "peu",

    },
    {
        id: 6,
        korean: "퍼",
        english: "peo",

    },
    {
        id: 7,
        korean: "퍄",
        english: "pya",

    },
    {
        id: 8,
        korean: "패",
        english: "pae",

    },
    {
        id: 9,
        korean: "폐",
        english: "pye",

    },
    {
        id: 10,
        korean: "표",
        english: "pyo",

    },
    {
        id: 11,
        korean: "펴",
        english: "pyeo",

    },
    {
        id: 12,
        korean: "퓨",
        english: "pyu",

        

    },

    {
        id: 13,
        korean: "판",
        english: "pan",

        

    },
    {
        id: 14,
        korean: "팍",
        english: "pak",

        

    },
    {
        id: 15,
        korean: "핌",
        english: "pim",
        

    },
    {
        id: 16,
        korean: "팢",
        english: "pat",
        

    },
    {
        id: 17,
        korean: "팧",
        english: "pah",
        

    },
    {
        id: 18,
        korean: "펍",
        english: "peob",
        

    },
          {
        id: 19,
        korean: "플",
        english: "peul",
        

    },
    {
        id: 20,
        korean: "팥",
        english: "pat",
        

    },
    {
        id: 21,
        korean: "팪",
        english: "paekk",
        

    },
    {
        id: 22,
        korean: "팬",
        english: "paen",
        

    },
    {
        id: 23,
        korean: "픠",
        english: "pui",
        

    },
    {
        id: 24,
        korean: "풔",
        english: "pwo",
        

    },

    {
        id: 25,
        korean: "퍝",
        english: "pyat",
        

    },
    {
        id: 26,
        korean: "팟",
        english: "pat",
        

    },
    {
        id: 27,
        korean: "팡",
        english: "pang",
        
    }
    
];

